var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tx-count d-flex flex-column align-items-center px-1 py-0 rounded"},[_c('strong',{staticClass:"m-0"},[_vm._v("Hace:")]),_c('p',{staticClass:"m-0 text-center",staticStyle:{"width":"max-content"}},[_vm._v(_vm._s(_vm.time))])])
}
var staticRenderFns = []

export { render, staticRenderFns }